'use client';
import type { Assign } from '@ark-ui/react';
import { Checkbox } from '@ark-ui/react';
import { type CheckboxVariantProps, checkbox } from '@terra/ui-styled-system';
import type { ComponentProps, HTMLStyledProps } from '@terra/ui-styled-system';
import { createStyleContext } from './utils/create-style-context';

const { withProvider, withContext } = createStyleContext(checkbox);

export type RootProviderProps = ComponentProps<typeof RootProvider>;
export const RootProvider = withProvider<
  HTMLLabelElement,
  Assign<
    Assign<HTMLStyledProps<'label'>, Checkbox.RootProviderProps>,
    CheckboxVariantProps
  >
>(Checkbox.RootProvider, 'root');

export type RootProps = ComponentProps<typeof Root>;
export const Root = withProvider<
  HTMLLabelElement,
  Assign<
    Assign<HTMLStyledProps<'label'>, Checkbox.RootProps>,
    CheckboxVariantProps
  >
>(Checkbox.Root, 'root');

export const Control = withContext<
  HTMLDivElement,
  Assign<HTMLStyledProps<'div'>, Checkbox.ControlProps>
>(Checkbox.Control, 'control');

export const Group = withContext<
  HTMLDivElement,
  Assign<HTMLStyledProps<'div'>, Checkbox.GroupProps>
>(Checkbox.Group, 'group');

export const Indicator = withContext<
  HTMLDivElement,
  Assign<HTMLStyledProps<'div'>, Checkbox.IndicatorProps>
>(Checkbox.Indicator, 'indicator');

export const Label = withContext<
  HTMLSpanElement,
  Assign<HTMLStyledProps<'span'>, Checkbox.LabelProps>
>(Checkbox.Label, 'label');

export {
  CheckboxContext as Context,
  CheckboxHiddenInput as HiddenInput,
} from '@ark-ui/react';
